import Dialog from '@mui/material/Dialog'
import Typography from '@mui/material/Typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faArchive, faXmark } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './AutoSubmitConfirmDialog.styles'

interface FundingConfirmDialogProps {
  open: boolean
  title: string
  body: string
  confirmLabel: string
  onCancel: () => void
  onConfirm: () => void
  confirmTestId?: string
  /** Defaults to archive icon (Archive / Unarchive flows). */
  icon?: IconDefinition
}

/** Shared Cancel / primary-confirm modal (Archive, status, etc.). */
export const FundingConfirmDialog = ({
  open,
  title,
  body,
  confirmLabel,
  onCancel,
  onConfirm,
  confirmTestId = 'funding-confirm-proceed',
  icon = faArchive,
}: FundingConfirmDialogProps) => {
  const { classes, cx } = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      classes={{ paper: classes.paper }}
      data-testid="funding-confirm-dialog"
    >
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <div className={classes.titleGroup}>
            <span className={classes.titleIcon}>
              <FontAwesomeIcon icon={icon} />
            </span>
            <Typography component="h2" className={classes.title}>
              {title}
            </Typography>
          </div>
        </div>
        <button
          type="button"
          className={classes.close}
          aria-label="Close"
          onClick={onCancel}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <div className={classes.body}>
        <Typography component="p" className={classes.bodyText}>
          {body}
        </Typography>
      </div>

      <div className={classes.footer}>
        <button
          type="button"
          className={cx(classes.button, classes.cancelButton)}
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className={cx(classes.button, classes.proceedButton)}
          onClick={onConfirm}
          data-testid={confirmTestId}
        >
          {confirmLabel}
        </button>
      </div>
    </Dialog>
  )
}
